/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DevelopmentalReportAiResponseDto } from '../../models/developmental-report-ai-response-dto';
import { RequestDevelopmentalReportAiDto } from '../../models/request-developmental-report-ai-dto';

export interface DocumentAiControllerDevelopmentalReportAi$Params {
  ticketId: string;
  centerId: string;
  type: string;
      body: RequestDevelopmentalReportAiDto
}

export function documentAiControllerDevelopmentalReportAi(http: HttpClient, rootUrl: string, params: DocumentAiControllerDevelopmentalReportAi$Params, context?: HttpContext): Observable<StrictHttpResponse<DevelopmentalReportAiResponseDto>> {
  const rb = new RequestBuilder(rootUrl, documentAiControllerDevelopmentalReportAi.PATH, 'post');
  if (params) {
    rb.path('ticketId', params.ticketId, {});
    rb.query('centerId', params.centerId, {});
    rb.query('type', params.type, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DevelopmentalReportAiResponseDto>;
    })
  );
}

documentAiControllerDevelopmentalReportAi.PATH = '/api/document-ai/developmental-report-ai/{ticketId}';
